const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')
const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const menu = () => import(/* webpackPrefetch: true */ '@/views/private/menu.vue')
const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')


const auditrail = () => import(/* webpackPrefetch: true */ '@/views/private/dashboard/auditrail/index.vue')
const monitoring = () => import(/* webpackPrefetch: true */ '@/views/private/dashboard/monitoring/index.vue')


const sekolah = () => import(/* webpackPrefetch: true */ '@/views/private/sekolah/data/index.vue')
const sekolah_add = () => import(/* webpackPrefetch: true */ '@/views/private/sekolah/data/add/index.vue')
const sekolah_update = () => import(/* webpackPrefetch: true */ '@/views/private/sekolah/data/update/_id.vue')
const sekolah_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sekolah/data/_id.vue')
const tahun_ajaran = () => import(/* webpackPrefetch: true */ '@/views/private/sekolah/tahun/index.vue')
const jabatan = () => import(/* webpackPrefetch: true */ '@/views/private/sekolah/jabatan/index.vue')
const hak_akses_guru_pegawai = () => import(/* webpackPrefetch: true */ '@/views/private/sekolah/hak-akses-guru-pegawai/index.vue')


const category_user = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/index.vue')
const category_user_add = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/add/index.vue')
const category_user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/edit/_id.vue')


const dokumen_legal = () => import(/* webpackPrefetch: true */ '@/views/private/dokumen-legal/index.vue')
const pusat_bantuan = () => import(/* webpackPrefetch: true */ '@/views/private/pusat-bantuan/index.vue')
const banner = () => import(/* webpackPrefetch: true */ '@/views/private/banner/index.vue')

const guru_pegawai = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/guru-pegawai/data-guru-pegawai/index.vue')
const guru_pegawai_add = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/guru-pegawai/data-guru-pegawai/add/index.vue')
const guru_pegawai_edit = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/guru-pegawai/data-guru-pegawai/edit/_id.vue')
const guru_pegawai_detail = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/guru-pegawai/data-guru-pegawai/_id.vue')
const bidang_studi = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/guru-pegawai/bidang-studi/index.vue')
const siswa = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/siswa/index.vue')
const siswa_detail = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/siswa/_id.vue')
const siswa_add = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/siswa/add/index.vue')
const siswa_edit = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/siswa/update/_id.vue')
const wali_murid = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/wali-murid/index.vue')
const wali_murid_detail = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/wali-murid/_id.vue')
const wali_murid_add = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/wali-murid/add/index.vue')
const wali_murid_edit = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/pengguna/wali-murid/update/_id.vue')
const kehadiran_guru = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kehadiran/guru-dan-pegawai/index.vue')
const kehadiran_guru_detail = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kehadiran/guru-dan-pegawai/_id.vue')
const kehadiran_siswa = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kehadiran/siswa/index.vue')
const kehadiran_buku_harian_kelas = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kehadiran/buku-harian-kelas/index.vue')
const kegiatan_siswa_data = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kegiatan-siswa/data-kegiatan/index.vue')
const kegiatan_siswa_jadwal = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kegiatan-siswa/jadwal-kegiatan/index.vue')
const kegiatan_siswa_rekap = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kegiatan-siswa/rekap-kegiatan/index.vue')
const komunikasi_informasi_slide_banner = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/komunikasi-informasi/slide-banner/index.vue')
const komunikasi_informasi_pengumuman_sekolah = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/komunikasi-informasi/pengumuman-sekolah/index.vue')
const komunikasi_informasi_pesan_otomatis = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/komunikasi-informasi/pesan-otomatis/index.vue')
const tugas_penilaian_dafar_tugas = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/tugas-penilaian/daftar-tugas/index.vue')
const tugas_penilaian_dafar_tugas_detail = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/tugas-penilaian/daftar-tugas/_id.vue')
const tugas_penilaian_monitoring_tugas = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/tugas-penilaian/monitoring-tugas/index.vue')
const tugas_penilaian_input_rekap_nilai = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/tugas-penilaian/input-rekap-nilai/index.vue')
const tugas_penilaian_generate_e_raport = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/tugas-penilaian/generate-e-raport/index.vue')

const portal_sekolah_portal_alumni = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/portal-alumni/index.vue')
const portal_sekolah_portal_alumni_data_alumni = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/portal-alumni/data-alumni/index.vue')
const portal_sekolah_portal_alumni_forum_alumni = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/portal-alumni/forum-alumni/index.vue')
const portal_sekolah_portal_alumni_karir_beasiswa = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/portal-alumni/karir-beasiswa/index.vue')
const portal_sekolah_informasi_sekolah_agenda_kegiatan = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/informasi-sekolah/agenda-kegiatan/index.vue')
const portal_sekolah_informasi_sekolah_berita_artikel = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/informasi-sekolah/berita-artikel/index.vue')
const portal_sekolah_informasi_sekolah_ekstrakurikuler = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/informasi-sekolah/ekstrakurikuler/index.vue')

const portal_sekolah_informasi_sekolah_profil_sekolah_banner_sekolah = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/informasi-sekolah/profil-sekolah/banner-sekolah/index.vue')
const portal_sekolah_informasi_sekolah_profil_sekolah_galeri_kontak = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/informasi-sekolah/profil-sekolah/galeri-kontak/index.vue')
const portal_sekolah_informasi_sekolah_profil__sekolah_program_kurikulum = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/informasi-sekolah/profil-sekolah/program-kurikulum/index.vue')
const portal_sekolah_informasi_sekolah_profil_sekolah_struktur_organisasi = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/informasi-sekolah/profil-sekolah/struktur-organisasi/index.vue')
const portal_sekolah_informasi_sekolah_profil_sekolah_visi_misi = () => import(/* webpackPrefetch: true */ '@/views/private/portal-sekolah/informasi-sekolah/profil-sekolah/visi-misi/index.vue')


const tes_minat_bakat_kelola_tes = () => import(/* webpackPrefetch: true */ '@/views/private/tes-minat-bakat/kelola-tes/index.vue')
const tes_minat_bakat_hasil_tes = () => import(/* webpackPrefetch: true */ '@/views/private/tes-minat-bakat/hasil-tes/index.vue')
const tes_minat_bakat_analisa_potensi = () => import(/* webpackPrefetch: true */ '@/views/private/tes-minat-bakat/analisa-potensi/index.vue')
const tes_minat_bakat_konfigurasi_tes = () => import(/* webpackPrefetch: true */ '@/views/private/tes-minat-bakat/konfigurasi-tes/index.vue')
const tes_minat_bakat_rekomendasi_karir = () => import(/* webpackPrefetch: true */ '@/views/private/tes-minat-bakat/rekomendasi-karir/index.vue')


const laporan_analisa_data_laporan_bulanan_sekolah = () => import(/* webpackPrefetch: true */ '@/views/private/laporan-analisa-data/laporan-bulanan-sekolah/index.vue')
const laporan_analisa_data_laporaan_kehadiran_siswa = () => import(/* webpackPrefetch: true */ '@/views/private/laporan-analisa-data/laporan-kehadiran-siswa/index.vue')
const laporan_analisa_data_rekap_keadaan_guru_pegawai = () => import(/* webpackPrefetch: true */ '@/views/private/laporan-analisa-data/rekap-keadaan-guru-pegawai/index.vue')
const laporan_analisa_data_rekap_keadaan_siswa = () => import(/* webpackPrefetch: true */ '@/views/private/laporan-analisa-data/rekap-keadaan-siswa/index.vue')
const laporan_analisa_data_talent_mapping_analisa_sekolah = () => import(/* webpackPrefetch: true */ '@/views/private/laporan-analisa-data/talent-mapping/analisa-sekolah/index.vue')
const laporan_analisa_data_talent_mapping_analisa_wilayah = () => import(/* webpackPrefetch: true */ '@/views/private/laporan-analisa-data/talent-mapping/analisa-wilayah/index.vue')
const laporan_analisa_data_talent_mapping_tracer_study_alumni = () => import(/* webpackPrefetch: true */ '@/views/private/laporan-analisa-data/talent-mapping/tracer-study-alumni/index.vue')


const kelas = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kelas-dan-jadwal/kelas/index.vue')
const kelas_detail = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kelas-dan-jadwal/kelas/_id.vue')
const jadwal = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kelas-dan-jadwal/jadwal/index.vue')
const jadwal_detail = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kelas-dan-jadwal/jadwal/_id.vue')
const kalender = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kelas-dan-jadwal/kalender/index.vue')


const mata_pelajaran = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kurikulum/mata-pelajaran/index.vue')
const modul = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kurikulum/modul/index.vue')
const kurikulum_slide_banner = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kurikulum/slide-banner/index.vue')
const kurikulum_informasi_kuriulum = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kurikulum/informasi-kurikulum/index.vue')
const kurikulum_informasi_kuriulum_detail = () => import(/* webpackPrefetch: true */ '@/views/private/manajemen-akademis/kurikulum/informasi-kurikulum/_id.vue')

const file_kosong = () => import(/* webpackPrefetch: true */ '@/views/private/folser-kosong/index.vue')


const routes = [
  {
    path: "/dashboard",
    name: "Data Statistik",
    component: dashboard,
    meta: {
      title: "Data Statistik"
    }
  },

  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      title: "Profile"
    }
  },

  {
    path: "/menu",
    name: "Menu",
    component: menu,
    meta: {
      title: "Menu"
    }
  },

  {
    path: "/dashboard/audit-trail",
    name: "Data Auditrail",
    component: auditrail,
    meta: {
      title: "Data Auditrail"
    }
  },

  {
    path: "/dashboard/monitoring",
    name: "Data Monitoring",
    component: monitoring,
    meta: {
      title: "Data Monitoring"
    }
  },

  {
    path: "/sekolah/data-sekolah",
    name: "Data Sekolah",
    component: sekolah,
    meta: {
      title: "Data Sekolah"
    }
  },

  {
    path: "/sekolah/data-sekolah/add",
    name: "Tambah Sekolah",
    component: sekolah_add,
    meta: {
      title: "Tambah Sekolah"
    }
  },

  {
    path: "/sekolah/data-sekolah/edit/:id",
    name: "Ubah Sekolah",
    component: sekolah_update,
    meta: {
      title: "Ubah Sekolah"
    }
  },

  {
    path: "/sekolah/data-sekolah/:id",
    name: "Detail Sekolah",
    component: sekolah_detail,
    meta: {
      title: "Detail Sekolah"
    }
  },

  {
    path: "/sekolah/tahun-ajaran",
    name: "Tahun Ajaran",
    component: tahun_ajaran,
    meta: {
      title: "Tahun Ajaran"
    }
  },

  {
    path: "/sekolah/jabatan",
    name: "Data Mater jabatan",
    component: jabatan,
    meta: {
      title: "Data Mater jabatan"
    }
  },

  {
    path: "/sekolah/hak-akses-guru-pegawai",
    name: "Hak Akses Guru & Pegawai",
    component: hak_akses_guru_pegawai,
    meta: {
      title: "Hak Akses Guru & Pegawai"
    }
  },

  {
    path: "/pengaturan-sistem/hak-akses/data-admin",
    name: "Data Admin",
    component: user,
    meta: {
      title: "Data Admin"
    }
  },

  {
    path: "/pengaturan-sistem/hak-akses/role-admin",
    name: "Role Admin",
    component: category_user,
    meta: {
      title: "Role Admin"
    }
  },

  {
    path: "/pengaturan-sistem/hak-akses/role-admin/add",
    name: "Role Admin Add",
    component: category_user_add,
    meta: {
      title: "Tambah Role Admin"
    }
  },

  {
    path: "/pengaturan-sistem/hak-akses/role-admin/edit/:id",
    name: "Role Admin Edit",
    component: category_user_edit,
    meta: {
      title: "Ubah Role Admin"
    }
  },

  {
    path: "/pengaturan-sistem/home-banner",
    name: "Data Home Banner",
    component: banner,
    meta: {
      title: "Data Home Banner"
    }
  },

  {
    path: "/pengaturan-sistem/dokumen-legal",
    name: "Data Dokumen Legal",
    component: dokumen_legal,
    meta: {
      title: "Data Dokumen Legal"
    }
  },

  {
    path: "/pengaturan-sistem/pusat-bantuan",
    name: "Data Pusat Bantuan",
    component: pusat_bantuan,
    meta: {
      title: "Data Pusat Bantuan"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-guru-pegawai",
    name: "Data Guru & Pegawai",
    component: guru_pegawai,
    meta: {
      title: "Data Guru & Pegawai"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-guru-pegawai/add",
    name: "Tambah Guru & Pegawai",
    component: guru_pegawai_add,
    meta: {
      title: "Tambah Guru & Pegawai"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-guru-pegawai/edit/:school_id/:id",
    name: "Ubah Guru & Pegawai",
    component: guru_pegawai_edit,
    meta: {
      title: "Ubah Guru & Pegawai"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-guru-pegawai/:school_id/:id",
    name: "Detail Pegawai",
    component: guru_pegawai_detail,
    meta: {
      title: "Detail Pegawai"
    }
  },

  {
    path: "/manajemen-akademik/kelas-jadwal/bidang-studi",
    name: "Data Guru Pengampu",
    component: bidang_studi,
    meta: {
      title: "Data Guru Pengampu"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-siswa",
    name: "Data Siswa",
    component: siswa,
    meta: {
      title: "Data Siswa"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-siswa/add",
    name: "Tambah Siswa",
    component: siswa_add,
    meta: {
      title: "Tambah Siswa"
    }
  },
  {
    path: "/manajemen-akademik/data-pengguna/data-siswa/edit/:school_id/:id",
    name: "Ubah Siswa",
    component: siswa_edit,
    meta: {
      title: "Ubah Siswa"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-siswa/:school_id/:id",
    name: "Detail Siswa",
    component: siswa_detail,
    meta: {
      title: "Detail Siswa"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-wali-murid",
    name: "Data Wali Murid",
    component: wali_murid,
    meta: {
      title: "Data Wali Murid"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-wali-murid/add",
    name: "Tambah Wali Murid",
    component: wali_murid_add,
    meta: {
      title: "Tambah Wali Murid"
    }
  },
  {
    path: "/manajemen-akademik/data-pengguna/data-wali-murid/edit/:school_id/:id",
    name: "Ubah Wali Murid",
    component: wali_murid_edit,
    meta: {
      title: "Ubah Wali Murid"
    }
  },

  {
    path: "/manajemen-akademik/data-pengguna/data-wali-murid/:school_id/:id",
    name: "Detail Wali Murid",
    component: wali_murid_detail,
    meta: {
      title: "Detail Wali Murid"
    }
  },

  {
    path: "/manajemen-akademik/kelas-jadwal/kelola-kelas",
    name: "Kelola Kelas",
    component: kelas,
    meta: {
      title: "Kelola Kelas"
    }
  },

  {
    path: "/manajemen-akademik/kelas-jadwal/kelola-kelas/:school_class_id/:id",
    name: "Detail Kelas",
    component: kelas_detail,
    meta: {
      title: "Detail Kelas"
    }
  },

  {
    path: "/manajemen-akademik/kelas-jadwal/jadwal-pembelajaran/:school_class_id/:id",
    name: "Detail Jadwal",
    component: jadwal_detail,
    meta: {
      title: "Detail Jadwal"  
    }
  },

  {
    path: "/manajemen-akademik/kelas-jadwal/jadwal-pembelajaran",
    name: "Jadwal Pembelajaran",
    component: jadwal,
    meta: {
      title: "Jadwal Pembelajaran"
    }
  },

  {
    path: "/manajemen-akademik/kelas-jadwal/kalender-akademik",
    name: "Kalender Akademik",
    component: kalender,
    meta: {
      title: "Kalender Akademik"
    }
  },


  {
    path: "/manajemen-akademik/kelas-jadwal/daftar-mata-pelajaran",
    name: "Daftar Mata Pelajaran",
    component: mata_pelajaran,
    meta: {
      title: "Daftar Mata Pelajaran"
    }
  },
  {
    path: "/manajemen-akademik/kurikulum-sekolah/upload-kelola-modul",
    name: "Upload & Kelola Modul",
    component: modul,
    meta: {
      title: "Upload & Kelola Modul"
    }
  },

  {
    path: "/manajemen-akademik/kurikulum-sekolah/slide-banner",
    name: "Slide Banner Kurikulum",
    component: kurikulum_slide_banner,
    meta: {
      title: "Slide Banner Kurikulum"
    }
  },

  {
    path: "/manajemen-akademik/kurikulum-sekolah/informasi-kurikulum",
    name: "Informasi Kurikulum",
    component: kurikulum_informasi_kuriulum,
    meta: {
      title: "Informasi Kurikulum"
    }
  },

  {
    path: "/manajemen-akademik/kurikulum-sekolah/informasi-kurikulum/:school_id/:id",
    name: "Detail Informasi Kurikulum",
    component: kurikulum_informasi_kuriulum_detail,
    meta: {
      title: "Detail Informasi Kurikulum"
    }
  },

  // {
  //   path: "/manajemen-akademik/kehadiran/kehadiran-guru-pegawai",
  //   name: "Kehadiran Guru & Pegawai",
  //   component: kehadiran_guru,
  //   meta: {
  //     title: "Kehadiran Guru & Pegawai"
  //   }
  // },

  // {
  //   path: "/manajemen-akademik/kehadiran/kehadiran-guru-pegawai/:school_id/:id",
  //   name: "Detail Kehadiran Guru & Pegawai",
  //   component: kehadiran_guru_detail,
  //   meta: {
  //     title: "Detail Kehadiran Guru & Pegawai"
  //   }
  // },

  // {
  //   path: "/manajemen-akademik/kehadiran/kehadiran-siswa",
  //   name: "Kehadiran Siswa",
  //   component: kehadiran_siswa,
  //   meta: {
  //     title: "Kehadiran Siswa"
  //   }
  // },

  {
    path: "/manajemen-akademik/buku-harian-kelas",
    name: "Buku Harian Kelas",
    component: kehadiran_buku_harian_kelas,
    meta: {
      title: "Buku Harian Kelas"
    }
  },

  {
    path: "/manajemen-akademik/kegiatan-siswa/data-kegiatan",
    name: "Data Kegiatan Siswa",
    component: kegiatan_siswa_data,
    meta: {
      title: "Data Kegiatan Siswa"
    }
  },

  {
    path: "/manajemen-akademik/kegiatan-siswa/jadwal-kegiatan",
    name: "Jadwal Kegiatan Siswa",
    component: kegiatan_siswa_jadwal,
    meta: {
      title: "Jadwal Kegiatan Siswa"
    }
  },

  {
    path: "/manajemen-akademik/kegiatan-siswa/rekap-kegiatan",
    name: "Rekap Kegiatan Siswa",
    component: kegiatan_siswa_rekap,
    meta: {
      title: "Rekap Kegiatan Siswa"
    }
  },

  {
    path: "/manajemen-akademik/komunikasi-informasi/slide-banner",
    name: "Slide Banner",
    component: komunikasi_informasi_slide_banner,
    meta: {
      title: "Slide Banner"
    }
  },

  {
    path: "/manajemen-akademik/komunikasi-informasi/pengumuman-sekolah",
    name: "Pengumuman Sekolah",
    component: komunikasi_informasi_pengumuman_sekolah,
    meta: {
      title: "Pengumuman Sekolah"
    }
  },
  {
    path: "/manajemen-akademik/komunikasi-informasi/pesan-otomatis",
    name: "Pesan Otomatis",
    component: komunikasi_informasi_pesan_otomatis,
    meta: {
      title: "Pesan Otomatis"
    }
  },
  {
    path: "/manajemen-akademik/tugas-penilaian/daftar-tugas",
    name: "Daftar Tugas",
    component: tugas_penilaian_dafar_tugas,
    meta: {
      title: "Daftar Tugas"
    }
  },
  {
    path: "/manajemen-akademik/tugas-penilaian/daftar-tugas/:school_id/:id",
    name: "Detail Tugas",
    component: tugas_penilaian_dafar_tugas_detail,
    meta: {
      title: "Detail Tugas"
    }
  },
  {
    path: "/manajemen-akademik/tugas-penilaian/monitoring-tugas",
    name: "Monitoring Tugas",
    component: tugas_penilaian_monitoring_tugas,
    meta: {
      title: "Monitoring Tugas"
    }
  },
  {
    path: "/manajemen-akademik/tugas-penilaian/input-rekap-nilai",
    name: "Input Rekap Nilai",
    component: tugas_penilaian_input_rekap_nilai,
    meta: {
      title: "Input Rekap Nilai"
    }
  },
  {
    path: "/manajemen-akademik/tugas-penilaian/generate-e-raport",
    name: "Generate E-Raport",
    component: tugas_penilaian_generate_e_raport,
    meta: {
      title: "Generate E-Raport"
    }
  },

  // {
  //   path: "/portal-sekolah/portal-alumni",
  //   name: "Portal Alumni",
  //   component: portal_sekolah_portal_alumni,
  //   meta: {
  //     title: "Portal Alumni"
  //   }
  // },
  {
    path: "/portal-sekolah/portal-alumni/data-alumni",
    name: "Data Alumni",
    component: portal_sekolah_portal_alumni_data_alumni,
    meta: {
      title: "Data Alumni"
    }
  },
  {
    path: "/portal-sekolah/portal-alumni/forum-alumni",
    name: "Forum Alumni",
    component: portal_sekolah_portal_alumni_forum_alumni,
    meta: {
      title: "Forum Alumni"
    }
  },
  {
    path: "/portal-sekolah/portal-alumni/karir-beasiswa",
    name: "Karir & Beasiswa",
    component: portal_sekolah_portal_alumni_karir_beasiswa,
    meta: {
      title: "Karir & Beasiswa"
    }
  },

  {
    path: "/portal-sekolah/informasi-sekolah/agenda-kegiatan",
    name: "Agenda Kegiatan",
    component: portal_sekolah_informasi_sekolah_agenda_kegiatan,
    meta: {
      title: "Agenda Kegiatan"
    }
  },

  {
    path: "/portal-sekolah/informasi-sekolah/berita-artikel",
    name: "Berita & Artikel",
    component: portal_sekolah_informasi_sekolah_berita_artikel,
    meta: {
      title: "Berita & Artikel"
    }
  },

  {
    path: "/portal-sekolah/informasi-sekolah/ekstrakurikuler",
    name: "Extrakurikuler",
    component: portal_sekolah_informasi_sekolah_ekstrakurikuler,
    meta: {
      title: "Extrakurikuler"
    }
  },
  {
    path: "/portal-sekolah/informasi-sekolah/profil-sekolah/banner-sekolah",
    name: "Banner Sekolah",
    component: portal_sekolah_informasi_sekolah_profil_sekolah_banner_sekolah,
    meta: {
      title: "Banner Sekolah"
    }
  },
  {
    path: "/portal-sekolah/informasi-sekolah/profil-sekolah/galeri-kontak",
    name: "Galeri & Kontak",
    component: portal_sekolah_informasi_sekolah_profil_sekolah_galeri_kontak,
    meta: {
      title: "Galeri & Kontak"
    }
  },
  {
    path: "/portal-sekolah/informasi-sekolah/profil-sekolah/program-kurikulum",
    name: "Program & Kurikulum",
    component: portal_sekolah_informasi_sekolah_profil__sekolah_program_kurikulum,
    meta: {
      title: "Program & Kurikulum"
    }
  },
  {
    path: "/portal-sekolah/informasi-sekolah/profil-sekolah/struktur-organisasi",
    name: "Struktur Organisasi",
    component: portal_sekolah_informasi_sekolah_profil_sekolah_struktur_organisasi,
    meta: {
      title: "Struktur Organisasi"
    }
  },

  {
    path: "/portal-sekolah/informasi-sekolah/profil-sekolah/visi-misi",
    name: "Visi & Misi",
    component: portal_sekolah_informasi_sekolah_profil_sekolah_visi_misi,
    meta: {
      title: "Visi & Misi"
    }
  },

  {
    path: "/tes-minat-bakat/kelola-tes",
    name: "Kelola Tes",
    component: tes_minat_bakat_kelola_tes,
    meta: {
      title: "Kelola Tes"
    }
  },

  {
    path: "/tes-minat-bakat/hasil-tes",
    name: "Hasil Tes",
    component: tes_minat_bakat_hasil_tes,
    meta: {
      title: "Hasil Tes"
    }
  },

  {
    path: "/tes-minat-bakat/analisa-potensi",
    name: "Analisa Potensi",
    component: tes_minat_bakat_analisa_potensi,
    meta: {
      title: "Analisa Potensi"
    }
  },

  {
    path: "/tes-minat-bakat/konfigurasi-tes",
    name: "Konfigurasi Tes",
    component: tes_minat_bakat_konfigurasi_tes,
    meta: {
      title: "Konfigurasi Tes"
    }
  },

  {
    path: "/tes-minat-bakat/rekomendasi-karir",
    name: "Rekomendasi Karir",
    component: tes_minat_bakat_rekomendasi_karir,
    meta: {
      title: "Rekomendasi Karir"
    }
  },

  {
    path: "/laporan-analisa-data/laporan-bulanan-sekolah",
    name: "Laporan Bulanan Sekolah",
    component: laporan_analisa_data_laporan_bulanan_sekolah,
    meta: {
      title: "Laporan Bulanan Sekolah"
    }
  },
  {
    path: "/laporan-analisa-data/laporan-kehadiran-siswa",
    name: "Laporan Kehadiran Siswa",
    component: laporan_analisa_data_laporaan_kehadiran_siswa,
    meta: {
      title: "Laporan Kehadiran Siswa"
    }
  },
  {
    path: "/laporan-analisa-data/rekap-keadaan-guru-pegawai",
    name: "Laporan Rekap Keadaan Guru & Pegawai",
    component: laporan_analisa_data_rekap_keadaan_guru_pegawai,
    meta: {
      title: "Laporan Rekap Keadaan Guru & Pegawai"
    }
  },
  {
    path: "/laporan-analisa-data/rekap-keadaan-siswa",
    name: "Laporan Rekap Keadaan Siswa",
    component: laporan_analisa_data_rekap_keadaan_siswa,
    meta: {
      title: "Laporan Rekap Keadaan Siswa"
    }
  },
  {
    path: "/laporan-analisa-data/talent-mapping/analisa-sekolah",
    name: "Analisa Sekolah",
    component: laporan_analisa_data_talent_mapping_analisa_sekolah,
    meta: {
      title: "Analisa Sekolah"
    }
  },
  {
    path: "/laporan-analisa-data/talent-mapping/analisa-wilayah",
    name: "Analisa Wilayah",
    component: laporan_analisa_data_talent_mapping_analisa_wilayah,
    meta: {
      title: "Analisa Wilayah"
    }
  },
  {
    path: "/laporan-analisa-data/talent-mapping/tracer-study-alumni",
    name: "Tracer Study Alumni",
    component: laporan_analisa_data_talent_mapping_tracer_study_alumni,
    meta: {
      title: "Tracer Study Alumni"
    }
  },

  {
    path: "/comming-soon",
    name: "Folder Kosong",
    component: file_kosong,
    meta: {
      title: "Folder Kosong"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})